import PropertyMediaContainer from "./PropertyMedia";
export default PropertyMediaContainer;
